import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TopicsService {
  public url: string;
  // public idTopicList: string;
  // public select: string;
  // public filter: string;
  // public order: string;

  constructor(
    private http: HttpClient,
  ) {
    this.url = environment.url + 'api/topics/';
    // this.idTopicList = environment.idTopicsList;
    // this.select = "$select=ID,Title,Imagen,ProgramaId";
    // this.order = "&$orderby=Orden";
  }

  public getAll() {
    return this.http.get(this.url);
  }

  public getByProgram(programaId: number) {
    return this.http.get(this.url + 'program/' + programaId);
  }

  public getById(topicId: number) {
    // this.filter = "$filter=Id eq " + topicId
    return this.http.get(this.url + topicId);
  }
}
